<div class="page-container container">
  <div class="row">
    <app-upload-content
      class="col-6"
      [paramItem]="viewItem"
    ></app-upload-content>
    <app-content-history
      class="col-6"
      (contentEmitter)="onViewCopy($event)"
    ></app-content-history>
  </div>
</div>
